
const IllustrationSection = () => {
  return (
    <section className="bg-white py-48">
      <div className="w-4/5 mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="w-24 h-px bg-[#2B2D33] mx-auto mb-8"></div>
          <h2
            className="text-5xl font-light text-[#2B2D33] leading-tight mb-16 text-center"
            style={{ fontFamily: 'Crimson Text, serif' }}
          >
            What Does 2% Mean?
          </h2>

          <p className="text-lg text-[#6B6D72] leading-relaxed mb-16 text-center max-w-3xl mx-auto">
            Small improvements compound in commercial trade businesses. Margin discipline applied systematically across operations creates measurable enterprise value.
          </p>

          {/* Simple Bar Graphic */}
          <div className="max-w-3xl mx-auto mb-16">
            <div className="grid grid-cols-[1fr_auto_1fr] gap-8 items-center">
              {/* Left Column */}
              <div className="text-center">
                <div className="border-2 border-[#2B2D33] p-8">
                  <p className="text-2xl font-light text-[#2B2D33] mb-2">$6M Revenue</p>
                  <p className="text-base text-[#6B6D72]">10% EBITDA ($600K)</p>
                </div>
              </div>

              {/* Arrow */}
              <div className="flex justify-center w-12 h-12 items-center">
                <i className="ri-arrow-right-line text-4xl text-[#B8963E]"></i>
              </div>

              {/* Right Column */}
              <div className="text-center">
                <div className="border-2 border-[#2B2D33] p-8">
                  <p className="text-2xl font-light text-[#2B2D33] mb-2">$6M Revenue</p>
                  <p className="text-base text-[#6B6D72]">12% EBITDA ($720K)</p>
                </div>
              </div>
            </div>
          </div>

          {/* Visual Diagram */}
          <div className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 md:grid-cols-[1fr_auto_1fr] gap-8 items-center border border-[#E5E7EB] rounded-lg p-12 bg-[#FAFAFA]">
              {/* Before */}
              <div className="text-center">
                <p className="text-sm text-[#6B6D72] uppercase tracking-wider mb-6">Before</p>
                <div className="space-y-4">
                  <div>
                    <p className="text-sm text-[#6B6D72] mb-1">Revenue</p>
                    <p className="text-2xl font-light text-[#2B2D33]">$6M</p>
                  </div>
                  <div className="pt-4 border-t border-[#E5E7EB]">
                    <p className="text-sm text-[#6B6D72] mb-1">EBITDA</p>
                    <p className="text-3xl font-light text-[#2B2D33]">10%</p>
                    <p className="text-lg text-[#6B6D72] mt-1">($600K)</p>
                  </div>
                </div>
              </div>

              {/* Arrow */}
              <div className="flex justify-center">
                <div className="flex flex-col items-center">
                  <i className="ri-arrow-right-line text-3xl text-[#B8963E]"></i>
                  <p className="text-xs text-[#6B6D72] mt-2 uppercase tracking-wider">+2%</p>
                </div>
              </div>

              {/* After */}
              <div className="text-center">
                <p className="text-sm text-[#6B6D72] uppercase tracking-wider mb-6">After</p>
                <div className="space-y-4">
                  <div>
                    <p className="text-sm text-[#6B6D72] mb-1">Revenue</p>
                    <p className="text-2xl font-light text-[#2B2D33]">$6M</p>
                  </div>
                  <div className="pt-4 border-t border-[#E5E7EB]">
                    <p className="text-sm text-[#6B6D72] mb-1">EBITDA</p>
                    <p className="text-3xl font-light text-[#1a1f2e]">12%</p>
                    <p className="text-lg text-[#6B6D72] mt-1">($720K)</p>
                  </div>
                  <div className="pt-4 border-t border-[#B8963E]/30">
                    <p className="text-sm text-[#6B6D72] mb-1">Enterprise Value Increase (at 4x)</p>
                    <p className="text-2xl font-medium text-[#B8963E]">+$480K</p>
                  </div>
                </div>
              </div>
            </div>

            <p className="text-sm text-[#6B6D72] leading-relaxed text-center mt-8 italic">
              (illustration, not a promise)
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IllustrationSection;
